import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  confirm(event) {
    event.preventDefault()

    const isDark = document.documentElement.classList.contains("dark")
    const message = this.element.dataset.swalMessage || "Tem certeza?"

    const title = this.element.dataset.swalTitle || "Remover álbum"
    const confirmText = this.element.dataset.swalConfirmText || "Sim, remover"

    window.Swal.fire({
      title: title,
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc2626",
      background: isDark ? "#1f2937" : "#fff",
      color: isDark ? "#f3f4f6" : "#1c1917",
      iconColor: isDark ? "#fbbf24" : undefined
    }).then(result => {
      if (result.isConfirmed) {
        this.element.closest("form").requestSubmit()
      }
    })
  }
}
